import DatabaseService from 'services/DatabaseService.js';
import {SET_CAROUSEL_ITEMS} from 'actions/types';
import {isCarouselLoaded,
        getCarouselItems,
        getCarouselItem}  from 'reducers/carouselItems.js';

//Action Creators
export const setCarouselItems = (carouselItems) => {
    return { type:SET_CAROUSEL_ITEMS, carouselItems:carouselItems};
}


//helpers
export const processCarouselItems = (dispatch, carouselItems) => {
    dispatch(setCarouselItems(carouselItems));
}


//Thunks
export const fetchCarouselItems = (force) => (dispatch, getState) => {
    if(!force) {
        var state = getState();
        if(isCarouselLoaded(state.carouselItems)) {
            return Promise.resolve(getCarouselItems(state.carouselItems));
        }
    }

    return new Promise(function(resolve, reject) {
        DatabaseService.getTimeline({carousel:true}).then( //timeline
            function(result) {
                console.log('fetchCarouselItems', result);
                var carouselItems = result.carouselItems;
                processCarouselItems(dispatch, carouselItems);
                resolve(carouselItems); 
            },
            function(error) {
                console.error(error);
                reject(error); 
            });
    });
}







// WEBPACK FOOTER //
// ./src/actions/carouselItems.js